module.exports = __webpack_public_path__ + "static/media/berrylangerak.46ef9eb2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/berrylangerak.webp
// module id = 896
// module chunks = 0